import React, { useState, useEffect } from 'react'
import styled from 'styled-components/macro'
import Logo from './Logo'
import Searchbar from './Searchbar'
import Button from './Button'
import ButtonFlag from './ButtonFlag'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { selectIsAuth } from '../../../redux/slices/auth'
import { logout } from '../../../redux/slices/auth'
import { useTranslation } from 'react-i18next'
import search from './../../../assets/search.svg';
import close from './../../MessageModal/close.svg';
import arrowDown from './../../../assets/arrow-down.png'
import logoutBtn from './../../../assets/logout.png'
import profileBtn from './../../../assets/profile.png'
import burger from '../../../assets/burger.png'
import BurgerMenu from './burger-menu/burger-menu'
import MenuAdapt from './menu-adapt/menu-adapt'
import avatarUrl from './../../UserLK/avatar.png';


const Section = styled.nav`

@media (max-width: 577px){
    margin-bottom: 0;
}
@media (max-width: 380px){
    width: 100%;
}
`
const TopNav = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
width: 75%;
margin: 1rem auto;
@media (max-width: 577px){
    width: calc(100% - 3rem);
    margin: 1rem 3rem;
}
`

const TopNavInner = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    max-width: 1450px;
    width: 100%;
`

const SearchbarCont = styled.div`
margin-top: 0rem;
margin-right: -5rem;

@media (max-width: 577px) {
    display: none;
}
`

const SearchbarMobileCont = styled.div`
display: none;

@media (max-width: 577px) {
    display: ${props => props.openMobileSearch ? 'flex' : 'none'};
    align-items: center;
    padding-left: 10px;
    margin-left: 10px;
}
`

const ButtonContainer = styled.div`
display: flex;
width: 300px;
margin-right: 7px;
justify-content: right;
position: relative;

.username{
    position: relative;
    bottom: -4px;
    right: 1rem;

    cursor: pointer;

    padding: 0 15px;

    &:hover, &:has(+ .drop-down.active) {
        background: hsla(30, 28%, 89%, 1);
        border-radius: 50px;
        padding-top: 4px;
        padding-bottom: 6px;
        bottom: 0px;
    }
}
.arrow{
    width: 20px;
    opacity: 0.7;
    margin-bottom: -5px;
    margin-right: 0px;
    cursor: pointer;
}

.drop-down{
    position: absolute;
    top: 38px;
    right: 20%;
    background: white;
    border-radius: 20px;
    padding: 10px 20px;
    min-width: 240px;

    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}

.drop-down h3 {
    font-size: 16px;
    font-family: 'Palatino';
    font-weight: 700;
}

.drop-down::before {
    content: '';
    position: absolute;
    top: -11px;
    left: 25px;
    height: 20px;
    width: 20px;
    transform: rotate(45deg);
}

.drop-down.active {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    transition: 0.5s ease;
    z-index: 25565;
    color: rgba(0, 0, 0, 0.8);
}

.drop-down.inactive {
    opacity: 0;
    visibility: hidden;
    transform: translateY(0px);
    transition: 0.5s ease;
}


h3{
    width: 100%;
    text-align: center;
    font-size: 10px;
    padding: 0px 0;
    font-weight: 500;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.8);
    line-height: 1.6rem;
}

h3 span{
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);
    font-weight: 400;
}

.drop-down ul li{
    padding: 10px 0;
    cursor: pointer;
}

.drop-down ul li:hover a{
}
.drop-down ul li:hover img{
    opacity: 1;
}
.dropdownItem {
    display: flex;
    margin: 10px auto;
}
.dropdownItem img{
    max-width: 20px;
    margin-right: 5px;
    margin-left: 40px;
    opacity: 0.5;
    transition: 0.5s ease;
}

.dropdownItem a{
    max-width: 100px;
    margin-left: 10px;
    transition: 0.5s ease;
}

.userInfoBlock {
    display: flex;
    flex-direction: row;
    gap: 12px;

    align-items: center;

    border-bottom: 1px solid rgba(148, 148, 148, 0.18);
    padding-bottom: 12px;

    img {
        height: 64px;
        width: 64px;
        border-radius: 64px;
    }
}

h5{
    font-size: 12pt;
    font-weight: 500;
}

@media (max-width: 577px){
    width: fit-content;
    margin-right: 0;

    .drop-down{
        display: none;
    }
}


`
const BotNav = styled.div`
background-color: rgba(234, 226, 218, 0.6);
height: 60px;
margin-top: -0.7rem;

@media (max-width: 577px){
    display: flex;
    justify-content: space-between;
}
`

const Menu = styled.ul`
    display: ${props => props.openMobileSearch ? 'none' : 'flex'};
    list-style: none;
    justify-content: center;
    align-items: center;
    height: 60px;
    text-transform: uppercase;
    font-family: 'Palatino';
    font-size: 13px;
    font-weight: 500;

    .item-hide {
        display: none;
    }

@media (max-width: 577px){
    justify-content: left;
    margin-left: 0.5rem;
    .item{
        display: none;
    }

    .item-hide {
        display: block;
    }
}
`

const MenuItem = styled.li`
margin: 0 1.6rem;
color: #000;
cursor: pointer;
transition: all 0.4s ease;
&:hover{
    transform: scale(1.3);
}

@media (max-width: 577px){
margin: 0.5rem;
width: 150;
}
`

const List = styled.ul`
list-style: none;
font-family: 'Montserrat';
margin-top: 0rem;
`

const ListItem = styled.li`
font-size: 14pt;
margin-left: 0rem;
padding-left: 1rem;
font-family: 'Palatino';

padding-bottom: 0.4rem;
padding-top: 0.4rem;
cursor: pointer;

&:last-child {
    border: none;
}
`

const SearchMobileBtn = styled.div`
    display: none;

    @media (max-width: 577px){
        cursor: pointer;
        margin-right: 8px;
        display: flex;
        align-items: center;

        img {
            display: block;
            width: 22px;
        }

        .close {
            width: 14px;
        }
    }
`

const BurgerBlock = styled.div`
    display: none;

    @media (max-width: 577px){
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 10px;
        margin-right: 17px;

        img {
            display: block;
            width: 22px;
        }

        .close {
            width: 14px;
        }
    }
`

const BurgerBtn = styled.img`
    display: none;

    @media (max-width: 577px){
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`

function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < breakpoint);
    checkScreen();
    
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, [breakpoint]);

  return isMobile;
}

const Navbar = () => {

 const isAuth = useSelector(selectIsAuth)
 const dispatch = useDispatch()
 const [open, setOpen] = useState(false);
 const [openMobileSearch, setOpenMobileSearch] = useState(false);
 const [isBurgerOpen, setIsBurgerOpen] = useState(false);

 const { t } = useTranslation()

 const isMobile = useIsMobile(768);

 const onClickLogout = () => {
    dispatch(logout())
    window.location.replace('/')
    window.localStorage.removeItem('token')  
 }

 const openMobileSearchHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenMobileSearch(!openMobileSearch)
 };

 const openBurgerMenuHandler = (e) => {
  e.preventDefault();
  e.stopPropagation();
  setIsBurgerOpen(true);
};

  return (
    <Section>
        <TopNav>
            <TopNavInner>
                <Link to="/"><Logo /></Link>
                            <SearchbarCont>
                                <Searchbar placeholder={t('search')}/>
                            </SearchbarCont>
                            <ButtonContainer>
                                {isAuth ? 
                                    <>
                                        <div style={{fontSize: 16, height: '20px', textAlign: 'right'}} className="username"
                                            onClick={() =>{
                                                setOpen(!open);
                                                window.innerWidth <= 577 &&
                                                setTimeout(() => {
                                                    setOpen(false);
                                                }, 11000);
                                            }}
                                        >
                                            {`${isAuth.username}`}
                                            <img src={arrowDown} className='arrow' alt='#'/>
                                        </div>
                    
                                        <div className={`drop-down ${open ? 'active' : 'inactive'} `}>
                                            <div style={{cursor: 'pointer', textAlign: 'right'}} onClick={() => { setOpen(false) }}>
                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M10.9344 0.181269C11.1884 -0.0710757 11.5891 -0.0584326 11.8281 0.209684C12.0669 0.477813 12.054 0.899651 11.8001 1.15192L6.92047 5.99947L11.8012 10.8482L11.8852 10.9493C12.0546 11.2028 12.0374 11.5557 11.8281 11.7904C11.6188 12.0249 11.2866 12.0638 11.0367 11.9006L10.9355 11.8188L5.99988 6.91442L1.06425 11.8188C0.810303 12.0711 0.410721 12.0584 0.171656 11.7904C-0.0673525 11.5223 -0.0552865 11.1005 0.198573 10.8482L5.07822 5.99947L0.19965 1.15192C-0.0542554 0.899657 -0.067144 0.477814 0.171656 0.209684C0.38081 -0.0249006 0.713118 -0.0634616 0.963037 0.0994351L1.06532 0.181269L5.99988 5.08338L10.9344 0.181269Z" fill="#949494"/>
                                                </svg>
                                            </div>
                                            <div className="userInfoBlock">
                                                <img src={isAuth.avatarUrl ? `https://toobears.com/api/${isAuth.avatarUrl}` : avatarUrl} alt="cardimg" />
                                                <h3>{`${isAuth.username}`} {`${isAuth.surname}`} <br /> {isAuth.shopname != null ? `${isAuth.shopname}` : ''}</h3>
                                            </div>
                                            <ul>
                                                <Link to="/account"><li className = 'dropdownItem'>
                                                    <img src={profileBtn} alt='profile' />
                                                    <h5>{t('profile')}</h5>
                                                </li></Link>

                                                <li className = 'dropdownItem' onClick={onClickLogout}>
                                                    <img src={logoutBtn} alt='logout' />
                                                    <h5>{t('logout')}</h5>
                                                </li>
                                            </ul>
                                        </div>
                                    </>
                                    : (<Link to="/auth/login"><Button text={t('login')} /></Link>)}
                                <ButtonFlag text="RU" />
                            </ButtonContainer>
            </TopNavInner>
            
        </TopNav>
        <BotNav>
            <SearchbarMobileCont openMobileSearch={openMobileSearch}>
                <Searchbar  placeholder={t('search')}/>
            </SearchbarMobileCont>
            <Menu openMobileSearch={openMobileSearch}>
                <MenuItem className='item'><Link to='cathegory'>{t('cathegory_menu')}</Link></MenuItem>
                <MenuItem className='item'><Link to='auctions'>{t('auctions')}</Link></MenuItem>
                <MenuItem className='item-hide'><Link to='/'>{t('Main')}</Link></MenuItem>
                <MenuItem><Link to='show' >{t('show')}</Link></MenuItem>
                <MenuItem className='item'><Link to='news'>{t('news')}</Link></MenuItem>
                {/*<MenuItem><Link to='sale'>{t('sale')}</Link></MenuItem>*/}
                <MenuItem className='item'><Link to='masterclass' >{t('pics')}</Link></MenuItem>
                <MenuItem className='item'><Link to='patterns' >{t('patterns')}</Link></MenuItem>
                <MenuItem className='item'><Link to='masters' className='link'>{t('masters')}</Link></MenuItem>
                {/* <MenuItem><Link to='news'>{t('news')}</Link></MenuItem> */}
            </Menu>
            <BurgerBlock>
                <SearchMobileBtn onClick={openMobileSearchHandler}>
                    {openMobileSearch ? 
                        <img className='close' src={close} alt='Close'/> :
                        <img src={search} alt='SearchMobile'/>
                    }            
                </SearchMobileBtn>
                <BurgerBtn alt='burger' src={burger} onClick={openBurgerMenuHandler}/>
            </BurgerBlock>
        </BotNav>
        <BurgerMenu isOpen={isBurgerOpen} onClose={() => setIsBurgerOpen(false)} />
        {isMobile && (
            <MenuAdapt isOpen={open} onClose={() => setOpen(false)} />
        )}
    </Section>
  )
}


export default Navbar